import { ChartCategoryPathMap } from "../Interfaces/chart-category-path-map";

export class AppConstants {
  static applicationName: string = "Chart Library - ";
  static barChartCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "Bar",
    chartModuleRoutePath: "BarChart",
    moduleFolderPath: "barchart\\barchart\\components\\" 
  }
  static stackedBarChartCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "StackedBar",
    chartModuleRoutePath: "StackBarChart",
    moduleFolderPath: "stacked-bar-chart\\stacked-bar-chart\\components\\"
  }
  static lollipopChartCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "Lollipop",
    chartModuleRoutePath: "LollipopChart",
    moduleFolderPath: "lollipop-chart\\lollipop-chart\\components\\"
  }
  
  static lineOrTrendCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "LineChart",
    chartModuleRoutePath: "LineChart",
    moduleFolderPath: "line-or-trend-chart\\line-or-trend-chart\\components\\"
  }
  static scatterCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "scatterChartTypes",
    chartModuleRoutePath: "ScatterChart",
    moduleFolderPath: "scatter-chart\\scatter-chart\\components\\"
  }
  static spiderCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "SpiderChart",
    chartModuleRoutePath: "SpiderChart",
    moduleFolderPath: "spider-chart\\spider-chart\\components\\"
  }
  static uniqueCategoryPathMap1: ChartCategoryPathMap = {
    chartCategory: "uniqueChartTypes1",
    chartModuleRoutePath: "FunnelChart",
    moduleFolderPath: "unique-chart1\\unique-chart1\\components\\"
  }
  static uniqueCategoryPathMap2: ChartCategoryPathMap = {
    chartCategory: "uniqueChartTypes2",
    chartModuleRoutePath: "UniqueChart2",
    moduleFolderPath: "unique-chart2\\unique-chart2\\components\\"
  }
  static pieCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "Pie",
    chartModuleRoutePath: "PieChart",
    moduleFolderPath: "pie-chart\\pie-chart\\components\\"
  }
  static areaCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "Area",
    chartModuleRoutePath: "AreaChart",
    moduleFolderPath: "area-chart\\area-chart\\components\\"
  }
  static donutCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "Donut",
    chartModuleRoutePath: "DonutChart",
    moduleFolderPath: "donut-chart\\donut-chart\\components\\"
  }
  // static combinationCategoryPathMap: ChartCategoryPathMap = {
  //   chartCategory: "Combination",
  //   chartModuleRoutePath: "CombinationChart",
  //   moduleFolderPath: "combinatation-chart\\combination-chart\\components\\"
  // }
  // static boxPlotSeriesCategoryPathMap: ChartCategoryPathMap = {
  //   chartCategory: "BoxPlotSeries",
  //   chartModuleRoutePath: "BoxPlotSeriesChart",
  //   moduleFolderPath: "box-plot-series-chart\\box-plot-series-chart\\components\\"
  // }
  // static pyramidChartCategoryPathMap: ChartCategoryPathMap = {
  //   chartCategory: "Pyramid",
  //   chartModuleRoutePath: "PyramidChart",
  //   moduleFolderPath: "pyramid-chart\\pyramid-chart\\components\\"
  // }
  // static vennDiagramCategoryPathMap: ChartCategoryPathMap = {
  //   chartCategory: "VennDiagramChart",
  //   chartModuleRoutePath: "VennDiagramChart",
  //   moduleFolderPath: "venn-diagram-chart\\venn-diagram-chart\\components\\"
  // }
  // static fillCategoryPathMap: ChartCategoryPathMap = {
  //   chartCategory: "FillChart",
  //   chartModuleRoutePath: "FillChart",
  //   moduleFolderPath: "fill-chart\\fill-chart\\components\\"
  // }
  static speedometerCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "SpeedometerChart",
    chartModuleRoutePath: "SpeedometerChart",
    moduleFolderPath: "speedometer-chart\\speedometer-chart\\components\\"
  }
  static TableCategoryPathMap: ChartCategoryPathMap = {
    chartCategory: "Table",
    chartModuleRoutePath: "TableView",
    moduleFolderPath: "tableView\\tableView\\components\\"
  }
}
